import { render } from "./QuickSendTemplateView.vue?vue&type=template&id=b9ca270a&scoped=true"
import script from "./QuickSendTemplateView.vue?vue&type=script&lang=js"
export * from "./QuickSendTemplateView.vue?vue&type=script&lang=js"

import "./QuickSendTemplateView.vue?vue&type=style&index=0&id=b9ca270a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ca270a"]])

export default __exports__